import {ExternalPdfFieldType, FieldType, IField, InternalPdfFieldType} from '@core/api/data-access';

export namespace FieldModelExtensionsUtils {
	export function isExternalField(type: any): boolean {
		return Object.values(ExternalPdfFieldType).includes(type);
	}

	export function isInternalField(type: any): boolean {
		return Object.values(InternalPdfFieldType).includes(type);
	}

	export function isFillableField(type: any): boolean {
		return [InternalPdfFieldType.image, InternalPdfFieldType.signature, InternalPdfFieldType.textBox, InternalPdfFieldType.checkBox].includes(type);
	}

	export function isAssignableToStationField(type: any): boolean {
		return isFillableField(type) || type === FieldType.attachment;
	}

	export function isDigitalSignatureField(field: IField): boolean {
		return (field.type === FieldType.signature && Boolean(field.value)) || typeof field.type !== 'string';
	}
}
